import { Stack, styled } from '@mui/material'

const Body = styled(Stack)`
  padding-top: 8px;
`

const SuggestionContainer = styled(Stack)`
  flex-direction: row;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  align-items: stretch;
`

const SuggestionHandler = styled(Stack)`
  width: 60px;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: ${({ theme }) => theme.palette.customGrey.one};
`

const SuggestionContent = styled(Stack)`
  height: 100%;
  flex: 1;
`

const MainContainer = styled(Stack)`
  flex: 1;
  box-shadow:
    0 0 8px rgba(0, 0, 0, 0.04),
    0 4px 16px rgba(238, 237, 237, 0.04);
`

const LabelSection = styled(Stack)`
  height: 56px;
  padding: 16px 24px;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
`

export {
  Body,
  SuggestionContainer,
  SuggestionHandler,
  SuggestionContent,
  MainContainer,
  LabelSection,
}
